import { Injectable } from "@angular/core";
import { Subscription } from "rxjs";
import { RequestAddBankDto, RequestBankGetHistoryDto, RequestEditBankDto, ResponseBankAccountGetHistoryDto, ResponseGetBankMultipleDto } from "../../../../shared/nestjs/gd-only/dto/multibank.dto";
import { MultiBankApi } from "../../../../shared/nestjs/gd-only/services/multibank.api";
import { NestResponsesProvider, ResponsePaging } from "../../../../shared/nestjs/nest-responses";
import { NestApiProvider } from "../../../../shared/nestjs/nest-api";

@Injectable()
export class ProfileBankAccountBloc {

  subscriptions: Array<Subscription> = [];

  constructor(
    public multiBankApi: MultiBankApi,
    public nestResponse: NestResponsesProvider,
    public nestApiProvider: NestApiProvider,
  ) { }

  getHistory(payload: RequestBankGetHistoryDto): Promise<ResponsePaging<ResponseBankAccountGetHistoryDto>> {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.multiBankApi.getHistory(payload)
          .subscribe((result) => {
            resolve(result)
          }, error => {
            reject(error);
          })
      )
    })
  }

  getBankSupport(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.multiBankApi.getBankSupport()
          .subscribe((result) => {
            resolve(result.listbank);
          }, error => {
            reject(error);
          })
      )
    })
  }

  getBankMultiDetail(payload: { empId: string }): Promise<ResponseGetBankMultipleDto> {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.multiBankApi.getBankMultiDetail(payload)
          .subscribe((result) => {
            resolve(result)
          }, error => {
            reject(error);
          })
      )
    })
  }

  addBankRequest(payload: RequestAddBankDto): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.multiBankApi.addBankRequest(payload)
          .subscribe((result) => {
            resolve(result);
          }, error => {
            reject(error);
          })
      )
    })
  }

  editBankRequest(payload: RequestEditBankDto): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.multiBankApi.editBankRequest(payload)
          .subscribe((result) => {
            resolve(result);
          }, error => {
            reject(error);
          })
      )
    })
  }

  dispose() {
    this.subscriptions.forEach((sub) => sub.unsubscribe);
  }
}


// WEBPACK FOOTER //
// ./src/bloc/feature/profile/profile-bank-account/profile-bank-account.bloc.ts